export const BASEAPIADDRESS = '/api';
export const BASEDATAVIEWADDRESS = `${BASEAPIADDRESS}/dataviews`;

export const APIURLS = {
    admin: {
        root: `${BASEAPIADDRESS}/admin`,
        updatePageCacheRefreshToken: `${BASEAPIADDRESS}/Admin/UpdatePageCacheRefreshToken`
    },
    adminCustomerRewards: `${BASEAPIADDRESS}/AdminCustomerRewards`,
    address: `${BASEAPIADDRESS}/address`,
    amazonAdmin: {
        root: `${BASEAPIADDRESS}/AmazonAdmin`
    },
    amazonManagement: `${BASEAPIADDRESS}/AmazonManagement`,
    amazonOAuth: {
        root: `${BASEAPIADDRESS}/AmazonOauth`
    },
    amazonProduct: {
        root: `${BASEAPIADDRESS}/AmazonProduct`,
        getByProductId: `${BASEAPIADDRESS}/AmazonProduct/GetByProductID/{{PRODUCTUID}}`,
        getSetupStatus: `${BASEAPIADDRESS}/AmazonProduct/GetSetupStatus`
    },
    attributeDetail: {
        root: `${BASEAPIADDRESS}/AttributeDetail`
    },
    autoSIMBrands: `${BASEAPIADDRESS}/AutoSIMBrands`,
    autoSIMCodeLookup: `${BASEAPIADDRESS}/AutoSimCodeLookup?productId={{PRODUCTUID}}`,
    banners: {
        root: `${BASEAPIADDRESS}/bannercollections`,
        filterable: `${BASEAPIADDRESS}/bannercollections/GetUsingGridRequestModel`,
        model: `${BASEAPIADDRESS}/bannercollections/Model`
    },
    bulkops: {
        product: {
            primaryCategory: `${BASEAPIADDRESS}/bulkproductoperations/SetPrimaryCategory`,
            majorItem: `${BASEAPIADDRESS}/bulkproductoperations/SetMajorItem`,
            buyersGuide: `${BASEAPIADDRESS}/bulkproductoperations/SetBuyersGuide`,
            deliveryDelay: `${BASEAPIADDRESS}/bulkproductoperations/SetDeliveryDelay`,
            relatedItems: `${BASEAPIADDRESS}/bulkproductoperations/SetFacetProductRelated`,
            blockMailOrder: `${BASEAPIADDRESS}/bulkproductoperations/SetBlockMailOrder`,
            restrictStorePickup: `${BASEAPIADDRESS}/bulkproductoperations/SetRestrictStorePickup`,
            deliveryChargesApply: `${BASEAPIADDRESS}/bulkproductoperations/SetDeliveryChargesApply`,
            inventoryTracked: `${BASEAPIADDRESS}/bulkproductoperations/SetInventoryTracked`,
            backorder: `${BASEAPIADDRESS}/bulkproductoperations/SetBackorder`,
            prelaunch: `${BASEAPIADDRESS}/bulkproductoperations/SetPrelaunch`,
            addToCollection: `${BASEAPIADDRESS}/bulkproductoperations/AddToCollection`,
            simStockStatus: `${BASEAPIADDRESS}/bulkproductoperations/SetSimStockStatus`
        },
        openingHours: {
            setOpeningTimes: `${BASEAPIADDRESS}/BulkOpeningHoursOperations/SetOpeningTimes`
        },
        findAndFilterCollection: {
            clearCollection: `${BASEAPIADDRESS}/BulkFindAndFilterCollectionOperations/ClearCollection`
        },
        ebayCategory: {
            replace: `${BASEAPIADDRESS}/BulkEbayCategoryOperations/Replace`
        },
        starBuys: {
            deleteItemToItem: `${BASEAPIADDRESS}/BulkStarBuysOperations/DeleteItemToItem`
        }
    },
    buyersguides: {
        root: `${BASEAPIADDRESS}/articleDictionary`,
        filterable: `${BASEAPIADDRESS}/articleDictionary/GetUsingGridRequestModel`,
        model: `${BASEAPIADDRESS}/articleDictionary/Model`
    },
    categories: `${BASEAPIADDRESS}/Categories`,
    clEBayAdmin: `${BASEAPIADDRESS}/EbayAdmin`,
    clEbayListed: {
        root: `${BASEAPIADDRESS}/EbayListed`,
        getByProductId: `${BASEAPIADDRESS}/EbayListed/GetByProductId`
    },
    clFlashImage: {
        root: `${BASEAPIADDRESS}/FlashImage`,
        getByProductId: `${BASEAPIADDRESS}/FlashImage/GetByProductID/{{PRODUCTUID}}`
    },
    clickAndCollectConfiguration: `${BASEAPIADDRESS}/clickAndCollectConfiguration`,
    clickAndCollectManagement: `${BASEAPIADDRESS}/ClickAndCollectManagement`,
    clMetapackAdmin: `${BASEAPIADDRESS}/MetapackAdmin`,
    cloudPosApi: `${BASEAPIADDRESS}/CloudPosApi`,
    clStockNotify: {
        root: `${BASEAPIADDRESS}/StockNotify`,
        deleteSentByProductId: `${BASEAPIADDRESS}/StockNotify/DeleteSentByProductId`,
        deletePendingByProductId: `${BASEAPIADDRESS}/StockNotify/DeletePendingByProductId`,
        model: `${BASEAPIADDRESS}/StockNotify/Model`
    },
    colourGroup: `${BASEAPIADDRESS}/ColourGroup`,
    colourGroupProduct: {
        root: `${BASEAPIADDRESS}/ColourGroupProduct`,
        getByProductId: `${BASEAPIADDRESS}/ColourGroupProduct/GetByProductId`,
        addToColourGroup: `${BASEAPIADDRESS}/ColourGroupProduct/AddToColourGroup`,
        removeFromColourGroup: `${BASEAPIADDRESS}/ColourGroupProduct/RemoveFromColourGroup`
    },
    configurationAudits: `${BASEAPIADDRESS}/ConfigurationDetails/SiteAudits`,
    configurationDetails: `${BASEAPIADDRESS}/ConfigurationDetails`,
    countryList: `${BASEAPIADDRESS}/CountryList`,
    cssBindings: `${BASEAPIADDRESS}/CSSBinding`,
    cssFragment: {
        root: `${BASEAPIADDRESS}/CSSFragment`,
        filterable: `${BASEAPIADDRESS}/CSSFragment/GetUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/CSSFragment/Model`
    },
    cssGroup: {
        root: `${BASEAPIADDRESS}/CSSGroup`,
        filterable: `${BASEAPIADDRESS}/CSSGroup/GetUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/CSSGroup/Model`
    },
    customer: {
        root: `${BASEAPIADDRESS}/Customer`,
        updateFromCustomerViewData: `${BASEAPIADDRESS}/Customer/UpdateFromViewData`,
        anonymise: `${BASEAPIADDRESS}/Customer/Anonymise`
    },
    customerManager: `${BASEAPIADDRESS}/CustomerManager`,
    customProductAttributes: {
        root: `${BASEAPIADDRESS}/CustomProductAttributes`,
        model: `${BASEAPIADDRESS}/CustomProductAttributes/Model`,
        byUid: `${BASEAPIADDRESS}/CustomProductAttributes/{{UID}}`
    },
    customProductAttributeDetail: {
        root: `${BASEAPIADDRESS}/CustomProductAttributeDetail`,
        byUid: `${BASEAPIADDRESS}/CustomProductAttributeDetail/{{UID}}`,
        byAttributeID: `${BASEAPIADDRESS}/CustomProductAttributeDetail/GetByAttributeID/{{ATTID}}`,
        model: `${BASEAPIADDRESS}/CustomProductAttributeDetail/Model`
    },
    customProductTemplateDefinitions: {
        root: `${BASEAPIADDRESS}/CustomProductTemplateDefinition`,
        GetEditModel: `${BASEAPIADDRESS}/CustomProductTemplateDefinition/GetEditModel/{{TEMPLATEID}}`
    },
    customProductTemplateMapping: {
        root: `${BASEAPIADDRESS}/CustomProductTemplateMapping`,
        getForTemplateId: `${BASEAPIADDRESS}/CustomProductTemplateMapping/GetAllMappingsForTemplateId/{{TEMPLATEID}}`,
        getForProductId: `${BASEAPIADDRESS}/CustomProductTemplateMapping/GetAllMappingsForProductId/{{PRODUCTID}}`
    },
    cycleschemeRestrictedFacets: `${BASEAPIADDRESS}/CycleschemeRestrictedFacetList`,
    googlecategories: `${BASEAPIADDRESS}/GoogleCategories`,
    fileDelete: {
        root: `${BASEAPIADDRESS}/FileDelete`
    },
    fileList: {
        root: `${BASEAPIADDRESS}/FileList`
    },
    fileUpload: `${BASEAPIADDRESS}/FileUpload`,
    login: `${BASEAPIADDRESS}/logon/logon/Authenticate`,
    ebayCategories: {
        importToCitrusStore: `${BASEAPIADDRESS}/EbayCategories/ImportToCitrusStore`,
        updateCategories: `${BASEAPIADDRESS}/EbayCategories/UpdateCategories`
    },
    eBayDownloadOrders: {
        root: `${BASEAPIADDRESS}/EbayDownloadOrders`
    },
    ebayItemOptions: {
        root: `${BASEAPIADDRESS}/EbayItemOptions`,
        model: `${BASEAPIADDRESS}/EbayItemOptions/Model`
    },
    eBayListing: {
        root: `${BASEAPIADDRESS}/EbayListing`,
        updateByProduct: `${BASEAPIADDRESS}/EbayListing/UpdateProductListings`
    },
    ebayProduct: {
        root: `${BASEAPIADDRESS}/EbayProduct`,
        getByProductId: `${BASEAPIADDRESS}/EbayProduct/GetByProductId`,
        getSetupStatus: `${BASEAPIADDRESS}/EbayProduct/GetSetupStatus`
    },
    ebayShipToExcluded: {
        root: `${BASEAPIADDRESS}/EbayShipToExcluded`,
        getByTemplateId: `${BASEAPIADDRESS}/EbayShipToExcluded/GetByTemplateId`
    },
    ebayShippingTable: {
        root: `${BASEAPIADDRESS}/EbayShippingTable`,
        filterableByTemplateId: `${BASEAPIADDRESS}/EbayShippingTable/GetForTemplateUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/EbayShippingTable/Model`
    },
    ebayTemplates: {
        root: `${BASEAPIADDRESS}/EbayTemplates`,
        filterable: `${BASEAPIADDRESS}/EbayTemplates/GetUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/EbayTemplates/Model`
    },
    facetCustomRepeaters: {
        root: `${BASEAPIADDRESS}/FafCustomRepeaters`,
        filterable: `${BASEAPIADDRESS}/FafCustomRepeaters/GetUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/FafCustomRepeaters/Model`
    },
    facetFilterDefinitions: `${BASEAPIADDRESS}/FacetFilterDefinition`,
    facetNavigation: {
        root: `${BASEAPIADDRESS}/FacetNavigation`,
        filterable: `${BASEAPIADDRESS}/FacetNavigation/GetUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/FacetNavigation/Model`
    },
    facetProductLink: {
        root: `${BASEAPIADDRESS}/FacetProductLink`,
        getByProductId: `${BASEAPIADDRESS}/FacetProductLink/GetByProductID/{{PRODUCTUID}}`,
        deleteByProductId: `${BASEAPIADDRESS}/FacetProductLink/DeleteByProductId`,
        model: `${BASEAPIADDRESS}/FacetProductLink/Model`
    },
    facetProductRelated: {
        root: `${BASEAPIADDRESS}/facetProductRelated`,
        getByProductId: `${BASEAPIADDRESS}/facetProductRelated/GetByProductID/{{PRODUCTUID}}`
    },
    facets: {
        root: `${BASEAPIADDRESS}/Facet`,
        filterableActivities: `${BASEAPIADDRESS}/Facet/GetActivityFacetsForFilterRequest`,
        filterableDepartments: `${BASEAPIADDRESS}/Facet/GetDepartmentFacetsForFilterRequest`,
        filterableItemGroups: `${BASEAPIADDRESS}/Facet/GetItemGroupFacetsForFilterRequest`,
        filterableMaterials: `${BASEAPIADDRESS}/Facet/GetMaterialFacetsForFilterRequest`,
        filterableDepartmentBrowseFilters: `${BASEAPIADDRESS}/Facet/GetDepartmentBrowseFilterFacetsByLevelAndDefinitionIdForFilterRequest`,
        filterableProductGroupBrowseFilters: `${BASEAPIADDRESS}/Facet/GetProductGroupBrowseFilterFacetsByLevelAndDefinitionIdForFilterRequest`
    },
    faqs: {
        root: `${BASEAPIADDRESS}/FaqTable`
    },
    filterCollections: {
        root: `${BASEAPIADDRESS}/FacetCollectionDefinitions`,
        filterable: `${BASEAPIADDRESS}/FacetCollectionDefinitions/GetUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/FacetCollectionDefinitions/Model`
    },
    financeProductRangeOperation: {
        createFinanceProducts: `${BASEAPIADDRESS}/financeProductRangeOperation/CreateFinanceProducts`
    },
    financeProduct: {
        root: `${BASEAPIADDRESS}/FinanceProduct`
    },
    financesetup: `${BASEAPIADDRESS}/FinanceSetup`,
    findAndFilterResultStats: `${BASEAPIADDRESS}/FindAndFilterResultStats`,
    findAndFilterURL: `${BASEAPIADDRESS}/FindAndFilterURL`,
    forwardOrderLoaderConfiguration: {
        root: `${BASEAPIADDRESS}/ForwardOrderLoaderConfiguration`
    },
    bannerEntries: {
        root: `${BASEAPIADDRESS}/BannerCollectionEntry`,
        filterableByParentId: `${BASEAPIADDRESS}/BannerCollectionEntry/GetForParentUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/BannerCollectionEntry/Model`
    },
    brands: {
        root: `${BASEAPIADDRESS}/brands`,
        filterable: `${BASEAPIADDRESS}/brands/GetUsingGridRequestModel`
    },
    discounts: {
        root: `${BASEAPIADDRESS}/discounts`,
        postRange: `${BASEAPIADDRESS}/discounts/PostRange`,
        model: `${BASEAPIADDRESS}/discounts/model`
    },
    generalPages: `${BASEAPIADDRESS}/GeneralPagesTbl`,
    giantCollectionLocations: {
        root: `${BASEAPIADDRESS}/GiantCollectionLocations`,
        updateLatLng: `${BASEAPIADDRESS}/GiantCollectionLocations/UpdateLatitudeLongitude`,
        model: `${BASEAPIADDRESS}/GiantCollectionLocations/Model`
    },
    giantDealers: {
        root: `${BASEAPIADDRESS}/GiantDealers`,
        getByDealerNumber: `${BASEAPIADDRESS}/GiantDealers/GetByDealerNumber`,
        model: `${BASEAPIADDRESS}/GiantDealers/Model`
    },
    integratedPaymentProcessingDetails: `${BASEAPIADDRESS}/IntegratedPaymentProcessingDetails`,
    integratedPaymentProcessingAction: `${BASEAPIADDRESS}/IntegratedPaymentProcessingAction`,
    inventory: {
        root: `${BASEAPIADDRESS}/Inventory`,
        getByProductID: `${BASEAPIADDRESS}/Inventory/GetByProductID/{{PRODUCTUID}}`
    },
    inventoryinfo: {
        root: `${BASEAPIADDRESS}/InventoryInfo`,
        updateSuppressSim: `${BASEAPIADDRESS}/InventoryInfo/UpdateSuppressSimValue/{{RECORDUID}}/{{SUPPRESSSETTING}}`
    },
    kountRiskCheckCredentials: {
        root: `${BASEAPIADDRESS}/KountRiskCheckCredentials`
    },
    linkCollections: `${BASEAPIADDRESS}/LinkCollection`,
    linkCollectionEntries: {
        root: `${BASEAPIADDRESS}/LinkCollectionEntries`
    },
    localisation: {
        root: `${BASEAPIADDRESS}/Localisation`
    },
    logFromFrontEnd: `${BASEAPIADDRESS}/LogErrorFromFrontEndUI`,
    mailQueue: {
        root: `${BASEAPIADDRESS}/MailQueue`,
        filterable: `${BASEAPIADDRESS}/MailQueue/GetUsingGridRequestModel`
    },
    paymentMethods: {
        root: `${BASEAPIADDRESS}/PaymentMethods`,
        getByName: `${BASEAPIADDRESS}/PaymentMethods/GetByName`
    },
    paymentProcessors: {
        root: `${BASEAPIADDRESS}/PaymentProcessors`,
        filterable: `${BASEAPIADDRESS}/PaymentProcessors/GetUsingFilterRequestModel`,
        getByName: `${BASEAPIADDRESS}/PaymentProcessors/GetByName`
    },
    payPalAuth: {
        root: `${BASEAPIADDRESS}/PayPalAuth`
    },
    payPalConfig: {
        root: `${BASEAPIADDRESS}/PayPalConfiguration`
    },
    productCollectionLink: {
        root: `${BASEAPIADDRESS}/ProductCollectionLink`,
        getByProductId: `${BASEAPIADDRESS}/ProductCollectionLink/GetByProductId`,
        model: `${BASEAPIADDRESS}/ProductCollectionLink/Model`
    },
    products: {
        root: `${BASEAPIADDRESS}/products`,
        getProductUrl: `${BASEAPIADDRESS}/products/getProductUrl`,
        deactivateProduct: `${BASEAPIADDRESS}/products/DeactivateProduct`,
        applyBuilderTemplate: `${BASEAPIADDRESS}/products/ApplyCustomBuilderTemplateToProduct`,
        removeBuilderTemplate: `${BASEAPIADDRESS}/products/RemoveCustomBuilderTemplateFromProduct`,
        removeOldBuilderInfo: `${BASEAPIADDRESS}/products/RemoveOldCustomBuilderFromProduct`
    },
    productSIMManagement: {
        root: `${BASEAPIADDRESS}/productsimmanagement`
    },
    reviews: {
        root: `${BASEAPIADDRESS}/review`
    },
    seasons: `${BASEAPIADDRESS}/season`,
    selectCountry: {
        root: `${BASEAPIADDRESS}/selectCountry`
    },
    selectState: {
        root: `${BASEAPIADDRESS}/selectState`
    },
    simAutomationStatus: `${BASEAPIADDRESS}/SimAutomationStatus`,
    siteDisplayOptions: `${BASEAPIADDRESS}/SiteDisplayOptions`,
    siteDataOptions: {
        root: `${BASEAPIADDRESS}/SiteDataOptions`
    },
    sizeFilterGroup: {
        root: `${BASEAPIADDRESS}/SizeFilterGroup`
    },
    sizeFilterRule: {
        root: `${BASEAPIADDRESS}/SizeFilterRule`,
        model: `${BASEAPIADDRESS}/SizeFilterRule/Model`
    },
    sizeFilterMapper: {
        refreshSizeFilters: `${BASEAPIADDRESS}/SizeFilterMapper/RefreshSizeFilters`
    },
    socialMediaLink: {
        root: `${BASEAPIADDRESS}/SocialMediaLink`
    },
    starBuy: {
        root: `${BASEAPIADDRESS}/StarBuy`
    },
    supplierIntegrationConfig: {
        root: `${BASEAPIADDRESS}/SupplierIntegrationConfig`
    },
    userSiteMessaging: `${BASEAPIADDRESS}/userSiteMessaging`,
    veeqoConfig: {
        root: `${BASEAPIADDRESS}/veeqo`,
        auth: `${BASEAPIADDRESS}/veeqo/auth`
    },
    version: `${BASEAPIADDRESS}/apiversion`,
    virtualTerminal: {
        sale: `${BASEAPIADDRESS}/virtualTerminal/sale`,
        refund: `${BASEAPIADDRESS}/virtualTerminal/refund`
    },
    views: {
        advancedProductSearch: {
            root: `${BASEDATAVIEWADDRESS}/AdvancedProductSearchView`
        },
        amazonProducts: {
            root: `${BASEDATAVIEWADDRESS}/amazonproductsview`
        },
        backInStock: {
            root: `${BASEDATAVIEWADDRESS}/BackInStockView`,
            csv: `${BASEDATAVIEWADDRESS}/BackInStockView/GetCsvExport`,
            getAllForProduct: `${BASEDATAVIEWADDRESS}/BackInStockView/GetAllForProductIdUsingGridRequestModel`,
            getPendingForProduct: `${BASEDATAVIEWADDRESS}/BackInStockView/GetPendingForProductIdUsingGridRequestModel`,
            getSentForProduct: `${BASEDATAVIEWADDRESS}/BackInStockView/GetSentForProductIdUsingGridRequestModel`
        },
        backInStockSummary: {
            getPending: `${BASEDATAVIEWADDRESS}/BackInStockSummaryView/GetPendingUsingGridRequestModel`,
            getSent: `${BASEDATAVIEWADDRESS}/BackInStockSummaryView/GetSentUsingGridRequestModel`
        },
        barcodelookup: `${BASEDATAVIEWADDRESS}/barcodelookupview`,
        brandLink: {
            root: `${BASEDATAVIEWADDRESS}/BrandLinkView`
        },
        categoryView: {
            root: `${BASEDATAVIEWADDRESS}/CategoryView`,
            getByParentName: `${BASEDATAVIEWADDRESS}/CategoryView/getByParentName`,
            leafOnlyFilterable: `${BASEDATAVIEWADDRESS}/CategoryView/GetLeafOnlyUsingFilterRequestModel`
        },
        clickAndCollectLocations: {
            available: `${BASEDATAVIEWADDRESS}/ClickAndCollectLocationsView/GetAvailableUsingFilterRequestModel`,
            unavailable: `${BASEDATAVIEWADDRESS}/ClickAndCollectLocationsView/GetUnavailableUsingFilterRequestModel`
        },
        clickAndCollectOrders: {
            root: `${BASEDATAVIEWADDRESS}/clickandcollectorderview`
        },
        colours: `${BASEDATAVIEWADDRESS}/Colours`,
        creditCardPaymentProcessor: {
            root: `${BASEDATAVIEWADDRESS}/CreditCardPaymentProcessor`
        },
        customerList: `${BASEDATAVIEWADDRESS}/CustomerListView`,
        detailedCouponUsage: {
            root: `${BASEDATAVIEWADDRESS}/DetailedCouponUsageView`,
            csv: `${BASEDATAVIEWADDRESS}/DetailedCouponUsageView/GetCsvExport`
        },
        discounts: {
            root: `${BASEDATAVIEWADDRESS}/discountview`,
            csv: `${BASEDATAVIEWADDRESS}/discountview/GetCsvExport`
        },
        discountusage: {
            root: `${BASEDATAVIEWADDRESS}/discountsused`,
            csv: `${BASEDATAVIEWADDRESS}/discountsused/GetCsvExport`
        },
        dpdPickups: `${BASEDATAVIEWADDRESS}/dpdorderview`,
        ebayImportCategories: {
            root: `${BASEDATAVIEWADDRESS}/EbayImportCategoriesView`
        },
        ebayItemSpecifics: {
            root: `${BASEDATAVIEWADDRESS}/EbayItemSpecificsView`
        },
        ebayLog: {
            root: `${BASEDATAVIEWADDRESS}/EbayLogView`,
            getLastWeek: `${BASEDATAVIEWADDRESS}/EbayLogView/GetLastWeekUsingGridRequestModel`,
            getForProduct: `${BASEDATAVIEWADDRESS}/EbayLogView/GetForProductUsingGridRequestModel`
        },
        ebayPlannerView: {
            root: `${BASEDATAVIEWADDRESS}/EbayPlannerView`
        },
        ebayProblemList: {
            root: `${BASEDATAVIEWADDRESS}/EbayProblemListView`
        },
        facetNavigationView: {
            all: `${BASEDATAVIEWADDRESS}/FacetNavigationView/{{SITENUMBER}}`,
            startAtParent: `${BASEDATAVIEWADDRESS}/FacetNavigationView/{{SITENUMBER}}/{{PARENTID}}`
        },
        financeProduct: {
            root: `${BASEDATAVIEWADDRESS}/FinanceProductView`,
            active: `${BASEDATAVIEWADDRESS}/FinanceProductView/GetActiveUsingGridRequestModel`
        },
        fullInventory: `${BASEDATAVIEWADDRESS}/FullInventoryView`,
        googleAnalyticsOrderPosting: {
            root: `${BASEDATAVIEWADDRESS}/GoogleAnalyticsOrderPostingView`
        },
        googleCategories: {
            root: `${BASEDATAVIEWADDRESS}/GoogleCategoriesView`
        },
        inactiveProducts: {
            getForWarehouse: `${BASEDATAVIEWADDRESS}/InactiveProductsView/GetForWarehouseUsingGridRequestModel`,
            getBySeasonForWarehouse: `${BASEDATAVIEWADDRESS}/InactiveProductsView/GetForCurrentSeasonForWarehouseUsingGridRequestModel`
        },
        inactiveStyles: {
            root: `${BASEDATAVIEWADDRESS}/InactiveStylesView`
        },
        invalidEbayCategories: {
            filterableByActiveProducts: `${BASEDATAVIEWADDRESS}/invalidebaycategoriesview/GetForActiveProductsUsingFilterRequestModel`
        },
        incorrectPrimaryCategories: {
            root: `${BASEDATAVIEWADDRESS}/incorrectprimarycategoriesview`
        },
        itemFilterQuickApply: {
            root: `${BASEDATAVIEWADDRESS}/ItemFilterQuickApplyView`,
            unassigned: `${BASEDATAVIEWADDRESS}/ItemFilterQuickApplyView/GetUnassignedFilters`
        },
        linkCollections: `${BASEDATAVIEWADDRESS}/LinkCollectionView`,
        linkCollectionEntries: `${BASEDATAVIEWADDRESS}/LinkCollectionEntriesView`,
        orderLinesReport: {
            root: `${BASEDATAVIEWADDRESS}/orderview`,
            csv: `${BASEDATAVIEWADDRESS}/orderview/GetCsvExport`,
            getStarbuysOnly: `${BASEDATAVIEWADDRESS}/orderview/GetForStarBuyUsingGridRequestModel`
        },
        orderDashboardSummaryReport: {
            root: `${BASEDATAVIEWADDRESS}/OrderDashBoardSummaryView?currentDate=[[CURRDATE]]&numberOfDailyTotals=[[NUMDAILY]]&numberOfMonthlyTotals=[[NUMMONTHLY]]`
        },
        orderSummaryReport: {
            root: `${BASEDATAVIEWADDRESS}/ordersummaryview`,
            csv: `${BASEDATAVIEWADDRESS}/orderSummaryView/GetCsvExport`
        },
        outOfStockButActive: {
            root: `${BASEDATAVIEWADDRESS}/OutofStockButActiveView`
        },
        orderViewMerchandiseSummary: {
            root: `${BASEDATAVIEWADDRESS}/orderViewMerchandiseSummaryView`
        },
        paymentActions: {
            getById: `${BASEDATAVIEWADDRESS}/PaymentActionsView/getById`
        },
        payments: {
            root: `${BASEDATAVIEWADDRESS}/PaymentsView`,
            subTotal: `${BASEDATAVIEWADDRESS}/PaymentsView/GetSubTotal`,
            csv: `${BASEDATAVIEWADDRESS}/PaymentsView/GetCsvExport`
        },
        payouts: {
            root: `${BASEDATAVIEWADDRESS}/PayoutView`,
            detail: `${BASEDATAVIEWADDRESS}/PayoutView/GetDetails`,
            csv: `${BASEDATAVIEWADDRESS}/PayoutView/GetCsvExport`,
            detailCsv: `${BASEDATAVIEWADDRESS}/PayoutView/GetDetailCsvExport`,
            detailSummary: `${BASEDATAVIEWADDRESS}/PayoutView/GetDetailsSummary`
        },
        paymentMethods: {
            root: `${BASEDATAVIEWADDRESS}/PaymentMethodsView`
        },
        productCategory: {
            filterable: `${BASEDATAVIEWADDRESS}/ProductsCategoryView/GetUsingFilterRequestModel`,
            filterableByCategoryId: `${BASEDATAVIEWADDRESS}/ProductsCategoryView/GetUsingCategoryIdAndFilterRequestModel`,
            filterableByProductId: `${BASEDATAVIEWADDRESS}/ProductsCategoryView/GetUsingProductIdAndFilterRequestModel`,
            filterableByCategoryIdAndActiveProducts: `${BASEDATAVIEWADDRESS}/ProductsCategoryView/GetUsingCategoryIdAndActiveProductsFilterRequestModel`
        },
        productColourGroup: `${BASEDATAVIEWADDRESS}/ProductColourGroupView`,
        productFilterable: `${BASEDATAVIEWADDRESS}/ProductFilterableView`,
        productSummary: `${BASEDATAVIEWADDRESS}/productsummaryview`,
        rangeViewer: `${BASEDATAVIEWADDRESS}/rangeviewerview`,
        reviews: {
            root: `${BASEDATAVIEWADDRESS}/reviewview`
        },
        faqsView: {
            root: `${BASEDATAVIEWADDRESS}/faqview`
        },
        relatedPayments: {
            root: `${BASEDATAVIEWADDRESS}/relatedPaymentsView`
        },
        selectCountry: {
            root: `${BASEDATAVIEWADDRESS}/selectCountryView`
        },
        selectCountryCode: `${BASEDATAVIEWADDRESS}/SelectCountryCodeView`,
        selectState: {
            root: `${BASEDATAVIEWADDRESS}/selectStateView`
        },
        simActivationLogStatus: {
            root: `${BASEDATAVIEWADDRESS}/SimActivationLogStatusView`
        },
        simLicenses: `${BASEDATAVIEWADDRESS}/simlicenseview`,
        sizeFilterRule: {
            root: `${BASEDATAVIEWADDRESS}/SizeFilterRuleView`
        },
        starBuys: {
            findAndFilter: `${BASEDATAVIEWADDRESS}/StarBuyView/GetFindAndFilterStarBuys`,
            itemToItem: `${BASEDATAVIEWADDRESS}/StarBuyView/GetItemToItemStarBuys`
        },
        stockLocationList: `${BASEDATAVIEWADDRESS}/stocklocationlistview`,
        stockLocations: {
            getForWarehouse: `${BASEDATAVIEWADDRESS}/StockLocationView/GetForWarehouseUsingGridRequestModel`
        },
        supplierIntegrationConfig: {
            root: `${BASEDATAVIEWADDRESS}/SupplierIntegrationConfigView`
        },
        suppressSim: {
            root: `${BASEDATAVIEWADDRESS}/SuppressSim`
        },
        transactionInformation: {
            getById: `${BASEDATAVIEWADDRESS}/TransactionInformationView/getById`
        }
    }
};

export default APIURLS;
